export default function useDataCounts() {
  const ctx = useNuxtApp()
  const client = ctx._apolloClients.default
  const fetchCounts = async () => {
    const res = await client.query({
      query: gql`
        query getCoreCounts {
          core {
            globalAgg {
              providersCount
              tariffsCount
              housesCount
              streetsCount
              citiesCount
              regionsCount
              totalClients
              tariffPriceMin
              tariffPriceMax
            }
          }
        }
      `,
      variables: {},
    })

    return res.data.core.globalAgg
  }

  return { fetchCounts }
}
